import { Button } from '@tunasong/ui-lib'
import { type FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import type { ModulationSubMode } from './modulation-lab-params.js'
import styles from './modulation-lab-welcome.module.css'

export interface ModulationLabWelcomeProps {
  preSubMode: ModulationSubMode | null
  onStartExplore: () => void
  onStartQuiz: () => void
}

/**
 * Modulation Lab welcome surface — two sub-mode cards (Explore + Quiz). Click
 * Explore to enter the free-explore audition view; click Quiz to start a
 * 10-question modulation-ID session.
 *
 * Spec: docs/superpowers/specs/2026-05-26-modulation-lab-v1-design.md §6
 */
export const ModulationLabWelcome: FC<ModulationLabWelcomeProps> = props => {
  const { preSubMode, onStartExplore, onStartQuiz } = props
  const toolCopy = useTheoryCopy('modulation-lab')
  const exploreCopy = useTheoryCopy('modulation-explore')
  const quizCopy = useTheoryCopy('modulation-quiz')

  return (
    <div className={styles.welcome}>
      <header className={styles.intro}>
        <h1 className={styles.title}>{toolCopy?.displayName ?? 'Modulation Lab'}</h1>
        {toolCopy?.body ? <p className={styles.tagline}>{toolCopy.body}</p> : null}
      </header>
      <div className={styles.subModeGrid}>
        <Button
          type="button"
          variant="outlined"
          onClick={onStartExplore}
          aria-pressed={preSubMode === 'explore'}
          className={styles.subModeCard}
        >
          <span className={styles.cardTitle}>{exploreCopy?.displayName ?? 'Modulation Explore'}</span>
          {exploreCopy?.body ? <span className={styles.cardBody}>{exploreCopy.body}</span> : null}
        </Button>
        <Button
          type="button"
          variant="outlined"
          onClick={onStartQuiz}
          aria-pressed={preSubMode === 'quiz'}
          className={styles.subModeCard}
        >
          <span className={styles.cardTitle}>{quizCopy?.displayName ?? 'Modulation ID Quiz'}</span>
          {quizCopy?.body ? <span className={styles.cardBody}>{quizCopy.body}</span> : null}
        </Button>
      </div>
    </div>
  )
}
